import React from "react";
import { CButton } from "@coreui/react";

const TableButtonTo = (props) => {
  const color =
    props.color === null || props.color === undefined ? "success" : props.color;
  const isDisplayAllow =
    props.isDisplayAllow === null || props.isDisplayAllow === undefined
      ? true
      : props.isDisplayAllow;
  return (
    <td className="py-2">
      {isDisplayAllow === true && (
        <CButton
          variant="outline"
          shape="square"
          size="sm"
          to={props.to}
          color={color}
        >
          {props.ButtonName}
        </CButton>
      )}
    </td>
  );
};

export default TableButtonTo;
